import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Income16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.5 6.5C10.5 7.05228 10.0523 7.5 9.5 7.5C8.94771 7.5 8.5 7.05228 8.5 6.5C8.5 5.94771 8.94771 5.5 9.5 5.5C10.0523 5.5 10.5 5.94771 10.5 6.5Z'
      fill='currentColor'
    />
    <path d='M11.75 4.5H13.25V8.5H11.75V4.5Z' fill='currentColor' />
    <path d='M7.25 8.5V4.5L5.75 4.5V8.5H7.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.25 1.75H15.75V11.25H3.25V1.75ZM4.75 3.25V9.75H14.25V3.25H4.75Z'
      fill='currentColor'
    />
    <path d='M1.75 12.75V5.5H0.25V14.25H13V12.75H1.75Z' fill='currentColor' />
  </Svg>
);

Income16.displayName = 'Income16';
export default Income16;
